import { render, staticRenderFns } from "./AppointmentsTable.vue?vue&type=template&id=13430f35&scoped=true&"
import script from "./AppointmentsTable.vue?vue&type=script&lang=js&"
export * from "./AppointmentsTable.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsTable.vue?vue&type=style&index=0&id=13430f35&prod&lang=css&"
import style1 from "./AppointmentsTable.vue?vue&type=style&index=1&id=13430f35&prod&scoped=true&lang=css&"
import style2 from "./AppointmentsTable.vue?vue&type=style&index=2&id=13430f35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13430f35",
  null
  
)

export default component.exports